import React from 'react';
import IconProvider from '../../SharedUI/components/IconProvider';
import { CRAFT_ELEMENTS } from '../config/craftElements';
import { ActionsController } from './ActionsController';
import { allowedFontSizes, getElementColor, hexToRGBA } from '../helper';
import { FUNNEL_THEME_KEYS } from '../../redux/interfaces/mainData';
import { useFunnelColorTheme } from '../../redux/slices/mainData';

enum IconType {
  icon = 'icon',
  emoji = 'emoji',
}

const IconComponentDefaultProps = {
  fontSize: 3,
  type: IconType.icon,
  value: 'FaSmileWink',
  color: FUNNEL_THEME_KEYS.ACCENT_COLOR,
  isCustomColor: false,
};

interface IconComponentDefaultPropsInterface {
  fontSize: number;
  type: IconType.icon;
  value: string;
  color: string;
  isCustomColor: boolean;
  align: string;
  isOutline?: boolean;
}

const IconComponent = (props: IconComponentDefaultPropsInterface): React.ReactElement => {
  const theme = useFunnelColorTheme();

  const isPropSizeValid = Object.prototype.hasOwnProperty.call(allowedFontSizes, props.fontSize);
  const icon = (
    <IconProvider
      name={props.value}
      color={getElementColor(props.color, theme)}
      style={{
        fontSize: `${isPropSizeValid ? props.fontSize : 4}em`,
        color: getElementColor(props.color, theme),
      }}
    />
  );
  return (
    <ActionsController className="icon__element" style={{ textAlign: props.align }}>
      {props.isOutline ? (
        <div
          style={{
            ...(props?.color && {
              background: hexToRGBA(getElementColor(props?.color, theme), 0.2),
            }),
          }}
          className="icon-outline"
          data-testid="icon-test-id"
        >
          {icon}
        </div>
      ) : (
        icon
      )}
    </ActionsController>
  );
};

IconComponent.craft = {
  name: CRAFT_ELEMENTS.ICON,
  props: IconComponentDefaultProps,
};

export default IconComponent;
